
import React from 'react';
import { TableRow, TableCell } from '@/components/ui/table';

interface IoTGatewayNoDataRowProps {
  isEmpty: boolean;
}

const IoTGatewayNoDataRow: React.FC<IoTGatewayNoDataRowProps> = ({ isEmpty }) => {
  return (
    <TableRow>
      <TableCell colSpan={9} className="text-center h-24 text-muted-foreground">
        {isEmpty ? 'No IoT gateway data found' : 'No gateways match current filters'}
      </TableCell>
    </TableRow>
  );
};

export default IoTGatewayNoDataRow;
